import { LINKS } from "./links";

const BLOCKS = [
  {
    title: "Easy Integration",
    text: "Bring size recommendations directly into the shopping experience.",
  },
  {
    title: "Shared Fit Intelligence",
    text: "Benefit from crowdsourced real-world fit experiences rather than relying only on your own transaction history.",
  },
  {
    title: "Built for Growing Ecommerce",
    text: "Designed with independent retailers and emerging brands in mind.",
  },
  {
    title: "Better Sizing Decisions",
    text: "Help shoppers make more informed size choices before ordering.",
  },
];

const ForRetailers = () => (
  <section id="retailers" data-testid="retailers-section" className="section-pad border-t border-[var(--line)]">
    <div className="container-x">
      <p className="eyebrow mb-6">For Retailers</p>
      <div className="max-w-2xl">
        <h2 className="font-display text-4xl leading-[1.1] tracking-tight sm:text-5xl">
          Fit intelligence without enterprise-level complexity.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[var(--ink-soft)]">
          Intuitive Shoes is designed to make crowdsourced fit recommendations
          accessible to independent and growing ecommerce businesses through
          lightweight integrations.
        </p>
      </div>

      <div data-testid="retailers-feature-grid" className="mt-14 grid gap-5 sm:grid-cols-2">
        {BLOCKS.map((block) => (
          <article
            key={block.title}
            data-testid={`retailer-block-${block.title.toLowerCase().replace(/\s+/g, "-")}`}
            className="card-line rounded-md p-8 transition-colors duration-300 hover:border-[var(--rust)]/40"
          >
            <h3 className="text-xs font-medium uppercase tracking-[0.18em] text-[var(--rust)]">
              {block.title}
            </h3>
            <p className="font-display mt-4 text-xl leading-snug">{block.text}</p>
          </article>
        ))}
      </div>

      <a href={LINKS.RETAILER_DEMO_URL} target="_blank" rel="noopener noreferrer" data-testid="retailers-demo-btn" className="btn-outline mt-12">
        See Retailer Demo
      </a>
    </div>
  </section>
);

export default ForRetailers;
